import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20Korean%20manhwa%20illustration%20background%2C%20soft%20warm%20teal%20and%20cream%20color%20palette%2C%20flowing%20geometric%20shapes%20with%20delicate%20linework%2C%20dreamy%20ethereal%20atmosphere%2C%20modern%20minimalist%20digital%20art%2C%20subtle%20gradients%2C%20light%20airy%20composition%20with%20negative%20space%2C%20no%20text%20or%20characters&width=1920&height=1080&seq=hero-bg-2026-x1&orientation=landscape"
          alt="韩漫画网 - 下拉式完整版韩漫免费阅读"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-3xl">
          <p className="text-background-50/80 text-sm md:text-base font-medium tracking-widest mb-4 md:mb-6 animate-fade-in">
            韩漫大全  ·  每日更新
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4 md:mb-6">
            下拉式完整版韩漫
            <br />
            无删减免费阅读
          </h1>
          <p className="text-background-50/70 text-sm md:text-lg max-w-xl mx-auto mb-8 md:mb-10 leading-relaxed">
            海量韩国漫画资源，高清画质流畅体验。韩漫画网为您提供最优质的韩漫在线阅读服务，每日更新不断。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm md:text-base transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              开始阅读
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category?tab=hot"
              className="px-8 py-3 border border-background-50/30 hover:border-background-50/60 text-background-50 font-medium rounded-full text-sm md:text-base transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              热门推荐
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}